import React from "react";
import { StyleSheet, Text, View } from "react-native";
import { TouchableOpacity } from "react-native-gesture-handler";
import { IntegrationColor } from "../../components/IntegrationColor";
import { titleCase } from "../../utils/titleCase";
import { Integration } from "../../api/WorthApi";

export const IntegrationCard = ({
  integration,
  onPress,
}: {
  integration: Integration;
  onPress?: () => void;
}) => {
  const isExpired =
    integration.source === "nordigen" && integration.data?.is_expired;
  const isExpiringSoon =
    integration.source === "nordigen" && integration.data?.is_expiring_soon;

  return (
    <TouchableOpacity
      key={integration._id}
      onPress={onPress}
      disabled={!onPress}
      style={styles.button}
    >
      <View>
        <View
          style={{
            flexDirection: "row",
            alignItems: "center",
            marginBottom: 4,
          }}
        >
          <IntegrationColor integrationId={integration._id} />
          <Text style={styles.type}>
            {integration.name || titleCase(integration.type)}
          </Text>
          {(isExpired || isExpiringSoon) && (
            <View
              style={[
                styles.statusBadge,
                { backgroundColor: isExpired ? "#ff0000" : "#ff9500" },
              ]}
            >
              <Text style={styles.statusText}>
                {isExpired ? "EXPIRED" : "EXPIRING"}
              </Text>
            </View>
          )}
        </View>
        <Text style={{ color: "white" }}>
          {titleCase(integration.type) + " - " + titleCase(integration.source)}
        </Text>
      </View>
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  type: { marginLeft: 6, fontSize: 16, color: "white" },
  button: {
    backgroundColor: "#343245",
    padding: 12,
    marginVertical: 6,
    borderRadius: 8,
    flexDirection: "row",
  },
  statusBadge: {
    marginLeft: 8,
    paddingHorizontal: 6,
    paddingVertical: 2,
    borderRadius: 4,
  },
  statusText: {
    color: "white",
    fontSize: 10,
    fontWeight: "bold",
  },
});
